import React, { useRef, useState } from "react";
import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { FiImage, FiUpload } from "react-icons/fi";
import api, { BASE_URL } from "../../Utils/api";
import "./MenuLogoUploadModal.css";

const ACCEPT_IMAGES = "image/jpeg,image/png,image/gif,image/webp";
const MAX_LOGO_MB = 4;

function MenuLogoUploadModal({ show, onHide, idEntidade, onSaved }) {
  const inputRef = useRef(null);
  const [logo, setLogo] = useState(null);
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);

  const limpar = () => {
    setLogo(null);
    setErro("");
    setSalvando(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const fechar = () => {
    if (salvando) return;
    limpar();
    if (onHide) onHide();
  };

  const selecionarLogo = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type?.startsWith("image/")) {
      setErro("Selecione um arquivo de imagem.");
      return;
    }

    if (file.size > MAX_LOGO_MB * 1024 * 1024) {
      setErro(`O logotipo deve ter no maximo ${MAX_LOGO_MB} MB.`);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setLogo(reader.result);
      setErro("");
    };
    reader.onerror = () => setErro("Nao foi possivel ler a imagem selecionada.");
    reader.readAsDataURL(file);
  };

  const salvar = async () => {
    if (!idEntidade) {
      setErro("Entidade nao identificada para salvar o logotipo.");
      return;
    }
    if (!logo) {
      setErro("Selecione uma imagem para continuar.");
      return;
    }

    setSalvando(true);
    setErro("");
    try {
      const authToken = localStorage.getItem("authToken");
      await api.put(
        `${BASE_URL}/api/empresasConfiguracoes/editarConfiguracoes/${idEntidade}`,
        { logotipo: logo },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            id_entidade: idEntidade,
          },
        }
      );
      if (onSaved) onSaved(logo);
      limpar();
      if (onHide) onHide();
    } catch (err) {
      setErro(
        err.response?.data?.message ||
          "Nao foi possivel salvar o logotipo. Tente novamente."
      );
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal show={show} onHide={fechar} centered size="sm">
      <Modal.Header closeButton={!salvando}>
        <Modal.Title className="menu-logo-modal-title">
          <FiImage aria-hidden="true" />
          Enviar logotipo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT_IMAGES}
          className="d-none"
          onChange={selecionarLogo}
        />

        <button
          type="button"
          className={`menu-logo-upload-zone${logo ? " has-logo" : ""}`}
          onClick={() => inputRef.current?.click()}
          disabled={salvando}
        >
          {logo ? (
            <img src={logo} alt="Previa do logotipo" />
          ) : (
            <>
              <FiUpload aria-hidden="true" />
              <span>Selecionar imagem</span>
            </>
          )}
        </button>

        {erro && (
          <Alert variant="danger" className="menu-logo-modal-alert">
            {erro}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={fechar} disabled={salvando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={salvar} disabled={salvando || !logo}>
          {salvando ? <Spinner animation="border" size="sm" /> : "Salvar logo"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MenuLogoUploadModal;
